import type { AppEnvType } from '../app-env';

export interface IAnalyticsVars {
  ga4MeasurementId: string;
  ga4AdminMeasurementId: string;
  metaPixelId: string;
  tiktokPixelId: string;
  googleAdsConversionId: string;
  mixpanelToken: string;
  appsFlyerKey: string;
  posthogKey: string;
}

const ga4WebMeasurementId = 'G-GN74L5N273';

const emptyIds = {
  ga4AdminMeasurementId: '',
  metaPixelId: '',
  tiktokPixelId: '',
  googleAdsConversionId: '',
  mixpanelToken: '',
  appsFlyerKey: '',
  posthogKey: '',
};

export const analyticsVars: Record<AppEnvType, IAnalyticsVars> = {
  local: { ga4MeasurementId: ga4WebMeasurementId, ...emptyIds },
  dev: { ga4MeasurementId: ga4WebMeasurementId, ...emptyIds },
  stg: { ga4MeasurementId: ga4WebMeasurementId, ...emptyIds },
  prod: { ga4MeasurementId: ga4WebMeasurementId, ...emptyIds },
};
